import { Tooltip } from 'src/design-system'
import * as React from 'react'
import cn from 'classnames'

export type OverviewCardProps = {
  description: string
  onClick: () => void
  selected: boolean
  value: number
  tooltipText?: string
}

export const OverviewCard = (props: OverviewCardProps) => {
  const { description, onClick, selected, value, tooltipText } = props

  const button = (
    <button
      className={cn(
        'px-3 py-1.5 rounded-full border transition-colors w-max whitespace-nowrap',
        selected
          ? 'bg-progression-green text-white !border-progression-green'
          : 'bg-white border-gray-100 text-gray-600'
      )}
      onClick={onClick}
    >
      {description} {value}
    </button>
  )

  return tooltipText ? (
    <Tooltip content={tooltipText}>{button}</Tooltip>
  ) : (
    button
  )
}
